import React from 'react'
import styled from 'styled-components'
import { desktopVw } from '../../styles/utils'
import { getLinkPath } from '../../utils'
import richTextRenderer from '../../utils/richTextRenderer'
import { accountStyleCTAButton } from '../Account/AccountStyle'
import Button from '../Button'
import ScaledImage from '../ScaledImage'

const BannerContainer = styled.div``

const StyledImage = styled(ScaledImage)`
  height: 209px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    height: ${desktopVw(400)};
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    flex-direction: row;
    padding: 0 ${desktopVw(485)};
  }
`

const ContactUsText = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 30px;

  h1 {
    font-family: ${props => props.theme.fonts.ivyHeadline};
    font-size: 30px;
    line-height: 38px;
  }

  p {
    text-align: center;
    font-family: ${props => props.theme.fonts.grosa};
    font-size: 16px;
    line-height: 22px;
    padding: 10px 0 0 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    padding: ${desktopVw(30)} ${desktopVw(470)};
    h1 {
      font-size: ${desktopVw(56)};
      line-height: ${desktopVw(64)};
    }
    p {
      padding: ${desktopVw(30)} 0 0 0;
      font-size: ${desktopVw(16)};
      line-height: ${desktopVw(22)};
    }
  }
`

const StyledButton = styled(Button)`
  ${accountStyleCTAButton}

  width: 220px;
  height: 60px;
  padding: 0px;

  p,
  a,
  div,
  span {
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    font-family: ${props => props.theme.fonts.grosa};
  }

  &:first-child {
    margin-bottom: 28px;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    width: ${desktopVw(220)};
    height: ${desktopVw(60)};

    &:first-child {
      margin: 0 ${desktopVw(30)} 0 0;
    }

    p,
    a,
    div,
    span {
      font-size: ${desktopVw(14)};
      line-height: ${desktopVw(16)};
    }
  }
`

export function BannerSection({ contactUsText, orderSvgs, section }) {
  return (
    <BannerContainer>
      <StyledImage fluid={section?.imageDesktop} alt={section?.image?.description || section?.image?.title} />
      <ContactUsText>{richTextRenderer(contactUsText?.text?.json)}</ContactUsText>
      <ButtonContainer>
        {orderSvgs.map((svg, idx) => (
          <StyledButton key={idx} btn to={getLinkPath(svg?.textLink)} state={{ activeAccordion: idx }}>
            {richTextRenderer(svg?.titleDesktop?.json)}
          </StyledButton>
        ))}
      </ButtonContainer>
    </BannerContainer>
  )
}
